<template>
  <div class="box">

    <h2>Выручка</h2>
    <h1 class="revenue_value">
      {{ formatNumber(data) }} {{ $store.state.currency }}
    </h1>
  </div>
</template>

<script>
    import {base_url} from "../../http";
    import {formatNumber} from "../../base/base_func";
    export default {
        name: "revenueChart2",
        data() {
            return {
                loading: true,
                data: ""
            };
        },
        // Загружаем данные для таблицы
        methods: {
            fetchRevenue: function () {
                this.loading = true;
                this.lastDraw++;
                let url = `${base_url}/charts/revenue/`;
                this.$http
                    .get(url, {
                        // params: this.fetchParams
                    })
                    .then(result => {
                        this.data = result.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            formatNumber(val) {
                return formatNumber(val);
            }
        },
        mounted: function () {
            this.fetchRevenue();
        }
    };
</script>

<style scoped>
  .box {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
    padding: 10px;
    border-radius: 20px;
  }
  .revenue_value {
    color: #23b400;
    font-size: 37px;
  }
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
  .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
    /*color: #2d8cf0;*/
    border-bottom: None;
    color: rgba(37, 215, 126, 1);
  }
  .ivu-menu-horizontal .ivu-menu-item, .ivu-menu-horizontal .ivu-menu-submenu {
    float: left;
    padding: 0 10px;
    position: relative;
    cursor: pointer;
    z-index: 3;
    transition: all .2s ease-in-out;
  }
  .box-header {
    white-space: nowrap;
    text-align: left;
    /*font-family: Gilroy;*/
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    /*color: rgba(14,37,74,1);*/
  }
</style>



// WEBPACK FOOTER //
// src/apps/home/revenueChart2.vue